import MembersMedia from "./MembersMedia";

export default function MembersMediaTab() {
  return (
    <div className="p-4 md:p-6">
      <h2 className="text-2xl font-semibold mb-6 text-taekwondo-red">
        Media Library
      </h2>
      <p className="text-sm text-gray-700 mb-4">
        Browse photos, videos, audio, and documents shared with members.
      </p>
      <MembersMedia showItemMeta={false} showVideoTitles />
    </div>
  );
}


